import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    sliderParagraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`,
    ListItem: p => p.accentWhite
  },
  LIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    sliderParagraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`,
    ListItem: p => p.tertiaryDark
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    sliderParagraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`,
    ListItem: p => p.tertiaryDark
  }
}
